import { ca } from '@cian/analytics';
import { ICommandEventSiteData } from '@cian/analytics/dist/command';

export const trackVideoPlaying = (eventData: ICommandEventSiteData) => {
  ca('eventSite', eventData);
};
